import { ThemeProvider, CssBaseline } from "@mui/material";
import Navigation from "./navigation/Navigation";
import theme from "./configs/Theme";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { useWebViewMessageHandler } from './hooks/useWebViewMessageHandler';

function App() {
  dayjs.locale("pt-br");
  // ATIVA O HANDLER DE MENSAGENS DO WEBVIEW
  // 
  // Esta linha é CRUCIAL! Sem ela, as mensagens do React Native
  // não serão processadas e o upload/download não funcionará
  useWebViewMessageHandler();
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navigation />
        <ToastContainer />
      </ThemeProvider>
      <div id="recaptcha-container"></div>
    </>
  );
}

export default App;
